
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-penilik/pegawai/perencanaan/perilaku-kerja/panduan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-penilik/pegawai/perencanaan/perilaku-kerja/panduan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-penilik/pegawai/perencanaan/perilaku-kerja/panduan"])
      });
    }
  